import readXlsxFile from "read-excel-file"
// import writeXlsxFile from "write-excel-file"

export type RecodeFeedShopWbType = {
  article: number
  GoodCode: string
  nmId: number
  sku: string
  count: number
  commission?: number
  sizes?: string
}

export const parseWbRecode = async (
  file: File,
): Promise<RecodeFeedShopWbType[]> => {
  const dataFromXslx = await readXlsxFile<RecodeFeedShopWbType>(file, {
    schema: RECODE_SCHEMA_JSON,
  })
  return dataFromXslx.rows
}

// todo
// export const downloadRecode = async () => {
//   try {
//     const { success, items } = await BaseApi.getWbRecode()
//     if (success) {
//       writeXlsxFile(items, {
//         schema: RECODE_SCHEMA_EXCEL,
//         fileName: "перекодировка самсон вб.xlsx",
//       })
//     } else {
//       NotificationService.showNotification({
//         level: "error",
//         message: "Произошла ошибка",
//       })
//     }
//   } catch (e) {}
// }

export const RECODE_SCHEMA_JSON = {
  article: {
    prop: "article",
    type: Number,
    required: true,
  },
  GoodCode: {
    prop: "GoodCode",
    type: String,
    required: true,
  },
  nmId: {
    prop: "nmId",
    type: Number,
    required: true,
  },
  sku: {
    prop: "sku",
    type: String,
    required: true,
  },
  count: {
    prop: "count",
    type: Number,
    required: true,
  },
  sizes: {
    prop: "sizes",
    type: String,
    required: false,
  },
  commission: {
    prop: "commission",
    type: Number,
    required: false,
  },
}

export const RECODE_SCHEMA_EXCEL = [
  {
    column: "article",
    value: (item: RecodeFeedShopWbType) => item.article,
  },
  {
    column: "GoodCode",
    value: (item: RecodeFeedShopWbType) => item.GoodCode,
  },
  {
    column: "nmId",
    value: (item: RecodeFeedShopWbType) => item.nmId,
  },
  {
    column: "sku",
    value: (item: RecodeFeedShopWbType) => item.sku,
  },
  {
    column: "count",
    value: (item: RecodeFeedShopWbType) => item.count,
  },
  {
    column: "sizes",
    value: (item: RecodeFeedShopWbType) => item.sizes,
  },
  {
    column: "commission",
    value: (item: RecodeFeedShopWbType) => item.commission,
  },
]
